import { createFileRoute, redirect } from '@tanstack/react-router';

import { PaymentSettings } from '~pages/payments/payment-settings/index';
import { UserRoles } from '~entities/users/model/types';
import { checkMinRoleValue } from '~shared/utils/role-guard';

const PendingComponent = () => {
  return (
    <div className='flex h-screen items-center justify-center'>Loading....</div>
  );
};

export const Route = createFileRoute('/_auth/_layout/payment/payment-settings')(
  {
    beforeLoad: async () => {
      const hasAccess = await checkMinRoleValue(UserRoles.SUPER_ADMIN);
      if (!hasAccess) {
        return redirect({
          to: '/dashboard',
        });
      }
    },
    pendingComponent: PendingComponent,
    component: PaymentSettings,
  },
);
